import { Route } from '@angular/router';

import {
  BringAFriendComponent,
  CallHistoryComponent,
  callHistoryResolver,
  ChatComponent,
  ContactListComponent,
  ContactListResolve,
  DidsComponent,
  DidsResolve,
  ErrorComponent,
  OptionsComponent,
  SessionResolver,
  ToolsComponent,
} from './components';

export const ROUTES: Route[] = [
  {
    path: '',
    resolve: { session: SessionResolver },
    children: [
      {
        path: '',
        redirectTo: '/options',
        pathMatch: 'full',
      },
      {
        path: 'options',
        component: OptionsComponent,
      },
      {
        path: 'contacts',
        component: ContactListComponent,
        resolve: {
          contactLists: ContactListResolve,
        },
      },
      {
        path: 'dids',
        component: DidsComponent,
        resolve: {
          dids: DidsResolve,
        },
      },
      {
        path: 'inbox',
        component: ChatComponent,
      },
      {
        path: 'history',
        component: CallHistoryComponent,
        resolve: { callHistory: callHistoryResolver },
      },
      {
        path: 'tools',
        component: ToolsComponent,
      },
      {
        path: 'bring-a-friend',
        component: BringAFriendComponent,
      },
    ],
  },
  { path: 'error', component: ErrorComponent },
];
